// Copyright (c) Bentley Systems
import { IntegrationProjectStage } from "../Models/integration-project-stage";
import { SaveProjectDto } from "../Models/save-project-dto";
import { VariableValidationRule, VariableValidationType } from "./xml-variable-extractor";

export type SaveProjectDtoFields = {
  name: string;
  uniqueName: string;
  description?: string;
  version: string;
  inputExample?: string;
  responseExample?: string;
  compiledXml: string;
  projectStage: IntegrationProjectStage;
  newVersionId?: string;
  previousVersionId?: string;
  isOdata: boolean;
  allowResultReuse: boolean;
  isEnabled: boolean;
  subscriptionNotRequired: boolean;
  isForIntegrationTest: boolean;
  validationRules: VariableValidationRule[];
};

export type SaveProjectDtoOptions = {
  isUpdate: boolean;
  sourceId?: string;
  includeValidations: boolean;
};

export function buildSaveProjectDto(
  fields: SaveProjectDtoFields,
  options: SaveProjectDtoOptions,
): SaveProjectDto {
  const saveProjectDto: SaveProjectDto = {
    name: fields.name,
    uniqueName: fields.uniqueName,
    description: fields.description,
    version: fields.version,
    inputExample: fields.inputExample,
    responseExample: fields.responseExample,
    compiledXml: fields.compiledXml,
    projectStageId: fields.projectStage,
    newVersionId: fields.newVersionId,
    prevVersionId: fields.previousVersionId,
    isOdata: fields.isOdata,
    allowResultReuse: fields.allowResultReuse,
    isEnabled: fields.isEnabled,
    subscriptionNotRequired: fields.subscriptionNotRequired,
    isForIntegrationTest: fields.isForIntegrationTest,
    variableValidations: options.includeValidations
      ? fields.validationRules.filter(
          (r) => r.validationTypeId !== VariableValidationType.None || r.isRequired,
        )
      : [],
  };
  if (options.isUpdate && options.sourceId !== undefined) {
    saveProjectDto.id = options.sourceId;
  }
  return saveProjectDto;
}
